export const SHORTCUT_ENABLED_KEY = 'SHORTCUT_ENABLED_KEY';
export const SHORTCUT_BINDINGS_KEY = 'SHORTCUT_BINDINGS_KEY';
export const SHORTCUT_PRESET_NAME_KEY = 'SHORTCUT_PRESET_NAME_KEY';
